import './App.css';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import AllPosts from './components/AllPosts';
import OnePost from './components/OnePost';
import { AnimatePresence } from 'framer-motion';

function App() {
  return (
    <Router>
    <AnimatePresence exitBeforeEnter>
    <div className="App">
   <Route component={AllPosts} path="/" exact/>
   <Route component={OnePost} path="/:slug"/>
    </div>
    </AnimatePresence>
    </Router>
  );
}

export default App;
